import request, { ResponseData } from './request'
import { getAppDomain } from 'common/util'
import { processVersionPath } from '@docs/common'

export interface IDevice {
  device_sn: string
  station_sn: string
}

const getDevList = async () => {
  return request<ResponseData<IDevice[]>>(`${await getAppDomain()}${await processVersionPath('get_devs_list')}`, {
    data: {
      num: 100,
      page: 0,
    },
    method: 'POST',
  }).then(async (res: any) => {
    return res.data as IDevice[]
  })
}

export default getDevList
